module.exports = __webpack_public_path__ + "img/河南.c359a968.png";